import { render } from "./SidebarDashboard.vue?vue&type=template&id=a953f41a&scoped=true"
import script from "./SidebarDashboard.vue?vue&type=script&lang=js"
export * from "./SidebarDashboard.vue?vue&type=script&lang=js"

import "./SidebarDashboard.vue?vue&type=style&index=0&id=a953f41a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a953f41a"]])

export default __exports__